var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11V3H7.314L5 3.62V5.949L7 5.41V11H9ZM22 8L18 3L14 8H17V21H19V8H22ZM8 16.5C7.73478 16.5 7.48043 16.3946 7.29289 16.2071C7.10536 16.0196 7 15.7652 7 15.5C7 15.2348 7.10536 14.9804 7.29289 14.7929C7.48043 14.6054 7.73478 14.5 8 14.5C8.26522 14.5 8.51957 14.6054 8.70711 14.7929C8.89464 14.9804 9 15.2348 9 15.5C9 15.7652 8.89464 16.0196 8.70711 16.2071C8.51957 16.3946 8.26522 16.5 8 16.5ZM10.573 17.044C10.9017 16.4961 11.0469 15.8575 10.9875 15.2213C10.928 14.5851 10.6669 13.9845 10.2423 13.507C9.81774 13.0296 9.25178 12.7001 8.62689 12.5667C8.00201 12.4333 7.35085 12.5029 6.76827 12.7653C6.18568 13.0278 5.70212 13.4694 5.38801 14.0258C5.0739 14.5822 4.94565 15.2244 5.02196 15.8588C5.09826 16.4932 5.37512 17.0867 5.81222 17.5528C6.24931 18.0188 6.8238 18.3332 7.452 18.45L5.979 21H8.289L10.573 17.044Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber);
export default __webpack_public_path__ + "static/media/Number.9845f612a34147f1e5eb4325f7dee52f.svg";
export { ForwardRef as ReactComponent };